module.exports = __webpack_public_path__ + "img/img_slide_sample01.329c1452.png";